var _path, _line, _line2, _line3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16.431,21.08h-.032c-2.942.104-5.888.103-8.83,0h0c-2.534-.089-4.567-2.122-4.655-4.656l-.02-.583c-.089-2.565-.089-5.132,0-7.698l.02-.582c.088-2.534,2.123-4.568,4.657-4.656l.044-.002c2.924-.101,5.85-.101,8.774,0h.043c2.535.089,4.569,2.124,4.657,4.658l.021.61c.088,2.546.088,5.095,0,7.641l-.021.609c-.088,2.534-2.122,4.569-4.656,4.657Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 8.233,
    y1: 8.226,
    x2: 8.233,
    y2: 15.762
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 12.001,
    y1: 11.994,
    x2: 12.001,
    y2: 15.762
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 15.769,
    y1: 8.978,
    x2: 15.769,
    y2: 15.762
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.4f9760716926a1f597db0b5e3cc54c35.svg";
export { ForwardRef as ReactComponent };